import {Intro} from "@/pages/common/Home/Cases/Intro";
import {SimpleSlider} from "@/pages/common/Home/components/SimpleSlider";
import {Try} from "@/pages/common/Home/components/Try";

import collaboration from "@images/home/cases/collaboration.png";
import crisis from "@images/home/cases/crisis.png";
import cultural from "@images/home/cases/cultural.png";
import eco from "@images/home/cases/eco.png";
import inclusive from "@images/home/cases/inclusive.png";
import leadership from "@images/home/cases/leadership.png";
import quote_bottom from "@images/home/cases/quote-bottom.png";
import quote_top from "@images/home/cases/quote-top.png";
import regulatory from "@images/home/cases/regulatory.png";
import service from "@images/home/cases/service.png";
import {usePopup} from "@layouts/popup/InfoPopup/PopupContext";
import {PresentationPopup} from "@popups/requestPopups/PresentationPopup";
import {Helmet} from "react-helmet";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

const ScenarioSlide = (props) => {
  const {title, image, color} = props;

  return (
    <div
      className={styles.scenario_slide}
      style={{background: `${color}`}}
    >
      <img
        src={image}
        alt={"image-bg"}
      />

      <h2>{title}</h2>
    </div>
  );
};

const FeedbackSlide = (props) => {
  const {title, subtitle, user_name, user_job} = props;

  return (
    <div className={styles.feedback_slide}>
      <img
        src={quote_top}
        alt={"quote"}
      />
      <img
        src={quote_bottom}
        alt={"quote"}
      />

      <div className={styles.feedback_slide_content}>
        <h2>{title}</h2>

        <p>{subtitle}</p>
      </div>

      <div className={styles.feedback_slide_user}>
        <div>
          <span>
            <b>{user_name}</b>
          </span>
          <span>{user_job}</span>
        </div>
      </div>
    </div>
  );
};

export const Cases = () => {
  const {isMobile} = useSelector((state) => state.common.settings);
  const {t} = useTranslation();

  const scenariosItems = [
    {
      id: 0,
      block: (
        <ScenarioSlide
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.scenarios.card_1"),
              }}
            />
          }
          image={eco}
          color={
            "linear-gradient(109deg, rgba(87, 57, 150, 0.50) 0%, rgba(245, 129, 213, 0.50) 100%)"
          }
        />
      ),
    },
    {
      id: 1,
      block: (
        <ScenarioSlide
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.scenarios.card_2"),
              }}
            />
          }
          image={service}
          color={
            "linear-gradient(90deg, #FFD293 0%, #FB9675 100%), rgba(255, 255, 255, 0.20)"
          }
        />
      ),
    },
    {
      id: 2,
      block: (
        <ScenarioSlide
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.scenarios.card_3"),
              }}
            />
          }
          image={inclusive}
          color={
            "linear-gradient(90deg, #FBC2EB 0%, #A6C1EE 100%), rgba(255, 255, 255, 0.20)"
          }
        />
      ),
    },
    {
      id: 3,
      block: (
        <ScenarioSlide
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.scenarios.card_4"),
              }}
            />
          }
          image={leadership}
          color={
            "linear-gradient(90deg, #D756E3 0%, #87E8FA 100%), rgba(255, 255, 255, 0.20)"
          }
        />
      ),
    },
    {
      id: 4,
      block: (
        <ScenarioSlide
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.scenarios.card_5"),
              }}
            />
          }
          image={crisis}
          color={
            "linear-gradient(64deg, #7F60BE 14.62%, #FC83DA 84.71%), rgba(255, 255, 255, 0.20)"
          }
        />
      ),
    },
    {
      id: 5,
      block: (
        <ScenarioSlide
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.scenarios.card_6"),
              }}
            />
          }
          image={regulatory}
          color={
            "linear-gradient(90deg, #FE974E 0%, #FEF4BA 100%), rgba(255, 255, 255, 0.20)"
          }
        />
      ),
    },
    {
      id: 6,
      block: (
        <ScenarioSlide
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.scenarios.card_7"),
              }}
            />
          }
          image={collaboration}
          color={
            "linear-gradient(90deg, #FB6267 0%, #7A9EF6 100%), rgba(255, 255, 255, 0.20)"
          }
        />
      ),
    },
    {
      id: 7,
      block: (
        <ScenarioSlide
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.scenarios.card_8"),
              }}
            />
          }
          image={cultural}
          color={
            "linear-gradient(90deg, #A040A9 0%, #59D4EA 100%), rgba(255, 255, 255, 0.20)"
          }
        />
      ),
    },
  ];

  const feedbackItems = [
    {
      id: 0,
      block: (
        <FeedbackSlide
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_1.title"),
              }}
            />
          }
          subtitle={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_1.desc"),
              }}
            />
          }
          user_name={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_1.name"),
              }}
            />
          }
          user_job={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_1.job"),
              }}
            />
          }
        />
      ),
    },
    {
      id: 1,
      block: (
        <FeedbackSlide
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_2.title"),
              }}
            />
          }
          subtitle={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_2.desc"),
              }}
            />
          }
          user_name={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_2.name"),
              }}
            />
          }
          user_job={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_2.job"),
              }}
            />
          }
        />
      ),
    },
    {
      id: 2,
      block: (
        <FeedbackSlide
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_3.title"),
              }}
            />
          }
          subtitle={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_3.desc"),
              }}
            />
          }
          user_name={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_3.name"),
              }}
            />
          }
          user_job={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_3.job"),
              }}
            />
          }
        />
      ),
    },
    {
      id: 3,
      block: (
        <FeedbackSlide
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_4.title"),
              }}
            />
          }
          subtitle={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_4.desc"),
              }}
            />
          }
          user_name={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_4.name"),
              }}
            />
          }
          user_job={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_4.job"),
              }}
            />
          }
        />
      ),
    },
    {
      id: 5,
      block: (
        <FeedbackSlide
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_5.title"),
              }}
            />
          }
          subtitle={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_5.desc"),
              }}
            />
          }
          user_name={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_5.name"),
              }}
            />
          }
          user_job={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_5.job"),
              }}
            />
          }
        />
      ),
    },
    {
      id: 6,
      block: (
        <FeedbackSlide
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_6.title"),
              }}
            />
          }
          subtitle={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_6.desc"),
              }}
            />
          }
          user_name={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_6.name"),
              }}
            />
          }
          user_job={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.feedback.card_6.job"),
              }}
            />
          }
        />
      ),
    },
  ];

  const {openPopup} = usePopup();

  const handleOpenPopup = () => {
    openPopup(<PresentationPopup />);
  };

  return (
    <>
      <Helmet title={t("head_title.cases")} />

      <div className={"container-big"}>
        <div className={styles.cases_page}>
          <Intro />

          <div className={"container-home"}>
            <div className={styles.additional}>
              <h3
                dangerouslySetInnerHTML={{
                  __html: t("page.cases.scenarios.title"),
                }}
              />

              <SimpleSlider
                loop
                cards={scenariosItems}
                between={!isMobile ? 0 : 16}
                perview={!isMobile ? 3 : 8}
                autoplay={1300}
                navigation={false}
                pagination
                style={"additional"}
              />
            </div>
          </div>

          <div className={"container-home"}>
            <Try
              size={35}
              title={
                <b
                  dangerouslySetInnerHTML={{
                    __html: t("page.cases.try"),
                  }}
                />
              }
              button={
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("page.cases.try_btn"),
                  }}
                />
              }
              onClickBtn={handleOpenPopup}
            />
          </div>

          <div className={styles.feedback}>
            <SimpleSlider
              loop={false}
              cards={feedbackItems}
              between={!isMobile ? 0 : 32}
              perview={!isMobile ? 2 : 2}
              navigation
              pagination
              style={"feedback"}
            />
          </div>
        </div>
      </div>
    </>
  );
};
